<form (click)="$event.stopPropagation(); inputRef.focus()" #search_form class="search-form" action="/search" [class.focus]="_isFocus">
    <input #inputRef class="w100" name="q" type="text" [attr.aria-label]="placeholder" [attr.title]="placeholder" [placeholder]="placeholder" />
    <button type="button" class="mat-icon" [attr.title]="tooltip" (click)="search_form.submit()" aria-label="Search">search</button>
    <input type="submit" (click)="search_form.submit()" hidden />
</form>
<!-- [ngClass]="{'blinking': isFocus}"-->
